export default (value, currency, { actualNumber = false } = {}) =>
  actualNumber && currency === 'JPY'
    ? `￥${value}`
    : new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency,
      }).format(value)
